import React from "react";
import "./contacts.css";
import { GoLocation } from "react-icons/go";
function Contacts() {
  return (
    <div className="container my-5">
      <hr className="divider my-5" />
      <h2 className="fs-2">
        <span>
          <GoLocation
            className="mx-3"
            style={{
              color: "golden",
            }}
          />
        </span>
        Офис продаж
      </h2>
      <br />
      <p>
        Ташкент, ул. Мирабад, резиденция Mirabad Avenue, блок D.
        <br />
        <br />
        <strong>+998 78 150-55-55</strong>
        <br />
        <br />
        <strong>
          <b>Пн-Пт — с 9:00 до 19:00 Сб-Вс — с 10:00 до 18:00</b>
        </strong>
        <br />
      </p>

      <hr className="divider my-5" />

      <div className="container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15552.654898193221!2d69.20429268608369!3d41.28309772207653!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38ae8ba578f4f58d%3A0xd7a2ecf23413b7a0!2sNajot%20Ta&#39;lim%20Chilonzor%20Filial!5e0!3m2!1sen!2s!4v1659104926856!5m2!1sen!2s"
          className="w-100"
          height="450"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
}

export default Contacts;
